import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  trackSessionLinkShareOtpFailedSpec,
  trackSessionLinkShareOtpVerifiedSpec,
  trackShareAccessChangedSpec,
  trackShareAccessRevokedSpec,
  trackShareButtonClickedSpec,
  trackShareEditRequestedSpec,
  trackShareExternalConfirmedSpec,
  trackShareExternalEmailAddedSpec,
  trackShareLinkCopiedSpec,
  trackShareLinkGeneratedSpec,
  trackShareMemberAddedSpec,
  trackShareMemberSearchedSpec,
  trackShareModalOpenedSpec,
  trackShareNotificationClickedSpec,
  trackShareNotificationReceivedSpec,
  trackShareSavedSpec,
  type SessionLinkShareOtpFailed,
  type SessionLinkShareOtpVerified,
  type ShareAccessChanged,
  type ShareAccessRevoked,
  type ShareButtonClicked,
  type ShareEditRequested,
  type ShareExternalConfirmed,
  type ShareExternalEmailAdded,
  type ShareLinkCopied,
  type ShareLinkGenerated,
  type ShareMemberAdded,
  type ShareMemberSearched,
  type ShareModalOpened,
  type ShareNotificationClicked,
  type ShareNotificationReceived,
  type ShareSaved,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const sharingEvents: SnowplowEventMap = {
  [TrackingEventName.ShareAccessChanged]: (props) =>
    trackShareAccessChangedSpec(props as ShareAccessChanged),
  [TrackingEventName.ShareAccessRevoked]: (props) =>
    trackShareAccessRevokedSpec(props as ShareAccessRevoked),
  [TrackingEventName.ShareButtonClicked]: (props) =>
    trackShareButtonClickedSpec(props as ShareButtonClicked),
  [TrackingEventName.ShareEditRequested]: (props) =>
    trackShareEditRequestedSpec(props as ShareEditRequested),
  [TrackingEventName.ShareExternalConfirmed]: (props) =>
    trackShareExternalConfirmedSpec(props as ShareExternalConfirmed),
  [TrackingEventName.ShareExternalEmailAdded]: (props) =>
    trackShareExternalEmailAddedSpec(props as ShareExternalEmailAdded),
  [TrackingEventName.ShareLinkCopied]: (props) =>
    trackShareLinkCopiedSpec(props as ShareLinkCopied),
  [TrackingEventName.ShareLinkGenerated]: (props) =>
    trackShareLinkGeneratedSpec(props as ShareLinkGenerated),
  [TrackingEventName.ShareMemberAdded]: (props) =>
    trackShareMemberAddedSpec(props as ShareMemberAdded),
  [TrackingEventName.ShareMemberSearched]: (props) =>
    trackShareMemberSearchedSpec(props as ShareMemberSearched),
  [TrackingEventName.ShareModalOpened]: (props) =>
    trackShareModalOpenedSpec(props as ShareModalOpened),
  [TrackingEventName.ShareNotificationClicked]: (props) =>
    trackShareNotificationClickedSpec(props as ShareNotificationClicked),
  [TrackingEventName.ShareNotificationReceived]: (props) =>
    trackShareNotificationReceivedSpec(props as ShareNotificationReceived),
  [TrackingEventName.ShareSaved]: (props) => trackShareSavedSpec(props as ShareSaved),
  [TrackingEventName.SessionLinkShareOtpFailed]: (props) =>
    trackSessionLinkShareOtpFailedSpec(props as SessionLinkShareOtpFailed),
  [TrackingEventName.SessionLinkShareOtpVerified]: (props) =>
    trackSessionLinkShareOtpVerifiedSpec(props as SessionLinkShareOtpVerified),
};
